import React from 'react'
import { Box, Typography } from '@mui/material'

interface Props {
    title: string
    subtitle?: React.ReactNode
    actions?: React.ReactNode
}

/** Orange page header used by every push screen (same markup as AuditLogs). */
const PushPageHeader: React.FC<Props> = ({ title, subtitle, actions }) => (
    <Box className="border-10 p-2 px-4 mixed-orange mb-4 both-circle d-flex align-items-center justify-content-between" sx={{ gap: 2, flexWrap: 'wrap' }}>
        <Box className="d-flex flex-column" sx={{ minWidth: 0, zIndex: 1 }}>
            <Typography className='fs-24 text-white fw-medium' sx={{ lineHeight: 1.1, overflowWrap: 'anywhere' }}>
                {title}
            </Typography>
            {subtitle}
        </Box>
        {actions && <Box className="d-flex align-items-center" sx={{ gap: 1.5, flexWrap: 'wrap', zIndex: 1 }}>{actions}</Box>}
    </Box>
)

export default PushPageHeader
